import React, { useEffect, useState } from "react";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { Divider, Paper } from "@material-ui/core";
import FactorTable from "./components/FactorTable";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getFactorUnitList, getGrouhMoshtari } from "Stores/actions";
import FactorService from "Services/http/endpoints/factor/FactorService";
import { CAL_FACTOR_PRICE, FACTOR_RESULT } from "Stores/actionTypes";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import PreventEntry from "./PreventEntry";
import SelectedUnitCount from "./SelectedUnitCount";
import CalcedFinalPrice from "./CalcedFinalPrice";
import FactorsButton from "./FactorsButton";
import FactorPreviewSetting from "./FactorPreviewSetting";
import SettingsUsageCharge from "./SettingsUsageCharge";
import SettingsCost from "./SettingsCost";
import SettingsGroupCustomer from "./SettingsGroupCustomer";
import SettingsPriceType from "./SettingsPriceType";
import { useTheme } from "@material-ui/core/styles";
import FactorType from "./FactorType";

const Factor = () => {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadingPart, setLoadingPart] = useState(0);
  const { selectedProject, factorPagination, factorResult } = useSelector(
    (state) => ({
      selectedProject: state.project.selectedProject,
      factorPagination: state.factor.factorPagination,
      factorResult: state.factor.factorResult,
    }),
  );
  const dispatch = useDispatch();
  const [factorModal, setFactorModal] = useState([]);
  const [defaultCost, setDefaultCost] = useState(null);
  const [defaultArchive, setDefaultArchive] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    (async () => {
      if (selectedProject) {
        setLoading(true);
        try {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdProject: selectedProject.Id,
            Limit: factorPagination.Limit,
            Page: 1,
          };
          setLoadingPart(getPercent(0, 10));
          await dispatch(getFactorUnitList(data));
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
          };
          setLoadingPart(getPercent(10, 30));
          const response = await FactorService.getFactorModels(params);
          setLoadingPart(getPercent(30, 50));
          const response2 = await FactorService.getFactorDefaultCost({
            ...params,
            id: selectedProject.Id,
          });
          setLoadingPart(getPercent(50, 70));
          const _DefaultCost = response2.data.Value;
          setDefaultCost(_DefaultCost);
          const updatedData = response.data.Value.map((data) => {
            return {
              ...data,
              label: data.Name,
              value: data.Id,
            };
          });
          setFactorModal(updatedData);
          if (updatedData.length === 0) setDisabled(true);
          else setDisabled(false);

          let grouhMoshtari = null;
          if (read("StypeU") === "1") {
            if (selectedProject) {
              (async () => {
                const params = {
                  KeyGroup: read("groupKey"),
                  KeyUser: read("userKey"),
                  IdProject: selectedProject.Id,
                };
                grouhMoshtari = await dispatch(getGrouhMoshtari(params));
                updateFromApi(_DefaultCost, grouhMoshtari);
              })();
            }
          } else {
            (async () => {
              const params = {
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
              };
              grouhMoshtari = await dispatch(getGrouhMoshtari(params));
              updateFromApi(_DefaultCost, grouhMoshtari);
            })();
          }
          setLoadingPart(getPercent(70, 90));

          const response3 = await FactorService.getListArchiveFactorProject({
            ...params,
            IdProject: selectedProject.Id,
          });
          setLoadingPart("100%");
          const archiveFactorProject = response3.data.Value.map((data) => {
            return {
              ...data,
              label: `${data.Sho} _ ${data.Tarikh} _ ${t("price")} : ${data.Price.toLocaleString()} ${t("moneyUnit")}`,
              value: data.Id,
            };
          });
          archiveFactorProject.push({ label: t("emptyInSelect"), value: 0 });
          setDefaultArchive(archiveFactorProject);
        } catch (err) {
          console.error("[catch error]", err);
        }
        setLoading(false);
      }
    })();
  }, [selectedProject]);

  const updateFromApi = async (defCosts, groupCustomer) => {
    const selected = groupCustomer.find(
      (item) => item.value === selectedProject.IdGroup,
    );
    let defGroup = null;
    if (selected) {
      defGroup = selected;
    } else {
      defGroup = groupCustomer[0];
    }
    let updateCosts = null;
    if (defCosts) {
      updateCosts = {
        CostMasrafi: defCosts.Masrafi,
        CostNasb: defCosts.Nasb,
        CostArc: defCosts.Arc,
        CostAngle: defCosts.Angle,
        Tax: defCosts.Tax,
      };
    }
    let updateGroup = null;
    if (defGroup) {
      updateGroup = {
        ChargePriceFitting: defGroup.ChargeFitting,
        ChargePriceGlass: defGroup.ChargeGlass,
        ChargePriceNet: defGroup.ChargeNet,
        ChargePriceOther: defGroup.ChargeOther,
        ChargePriceProfile: defGroup.ChargeProfile,
        DiscountPriceFitting: defGroup.DiscountFitting,
        DiscountPriceGlass: defGroup.DiscountGlass,
        DiscountPriceNet: defGroup.DiscountNet,
        DiscountPriceOther: defGroup.DiscountOther,
        DiscountPriceProfile: defGroup.DiscountProfile,
      };
    }
    const result = {
      ...factorResult,
      ...updateCosts,
      ...updateGroup,
      ListUnitId: [],
      CheckAll: true,
      RoundPrice: 10,
      PriceTransfer: 0,
      CostJanebi: 0,
      IsPercentCostJanebi: true,
      IsPercentCostMasrafi: true,
      IsPercentCostNasb: true,
      ChargeValueFrameLola: 0,
      ChargeValueFrameRail: 0,
      ChargeValueSashLola: 0,
      ChargeValueSashRail: 0,
      ChargeValueSashDoorLola: 0,
      ChargeValueSashDoorRail: 0,
      ChargeValueMulionLola: 0,
      ChargeValueMulionRail: 0,
      ChargeValuePanelLola: 0,
      ChargeValuePanelRail: 0,
      ChargeValueZehvarLola: 0,
      ChargeValueZehvarRail: 0,
      ChargeValueOtherLola: 0,
      ChargeValueOtherRail: 0,
      ChargeValueProfile: 0,
      ChargeValueGlass: 0,
      ChargeValueNet: 0,
      ParamConvert: [],
      ModelOptimalFactor: 0,
      WeastOptimalFactor: 0,
      LenBranch: 6000,
      TypePriceProfile: 1,
      TypePriceFitting: 1,
      TypePriceGlass: 1,
      TypePriceNet: 1,
      TypePriceOther: 1,
      ParamKhadamat: [],
      IdFactorArchive: 0,
      customerGroupChanged: false,
      customerGroupNewValue: -1,
      IsPercentChargePriceProfile: true,
      IsPercentChargePriceFitting: true,
      IsPercentChargePriceGlass: true,
      IsPercentChargePriceNet: true,
      IsPercentChargePriceOther: true,
      IsPercentDiscountPriceProfile: true,
      IsPercentDiscountPriceFitting: true,
      IsPercentDiscountPriceGlass: true,
      IsPercentDiscountPriceNet: true,
      IsPercentDiscountPriceOther: true,
      DiscountPrice: 0,
      IsCalcPriceUnit: false,
    };
    await dispatch({ type: FACTOR_RESULT, factorResult: result });
    dispatch({ type: CAL_FACTOR_PRICE, price: null });
  };

  const getPercent = (min, max) => {
    const percent = Math.floor(Math.random() * (max - min) + min);
    return `${percent}%`;
  };

  return (
    <>
      {loading ? (
        <BackDropLoading loading={loading} percent={loadingPart} />
      ) : disabled ? (
        <PreventEntry />
      ) : (
        <>
          <div className="d-flex flex-column mt-2">
            <FactorsButton disabled={disabled} />
            <div className="d-flex flex-column flex-sm-row g-1 justify-content-start my-2">
              <FactorType />
              <Divider
                orientation="vertical"
                flexItem
                className="mx-2 d-none d-sm-block"
              />
              <SelectedUnitCount />
              <Divider
                orientation="vertical"
                flexItem
                className="mx-2 d-none d-sm-block"
              />
              <CalcedFinalPrice />
            </div>

            <Paper className="w-100 mb-3" dir={direction}>
              <FactorPreviewSetting factorModal={factorModal} />
            </Paper>

            <TabContext value={value}>
              <Box>
                <TabList onChange={handleChange} variant="scrollable">
                  <Tab
                    icon={<Icons.Layers />}
                    label={t("Select_the_unit")}
                    value="1"
                  />
                  <Tab
                    icon={<Icons.JournalPlus />}
                    label={t("chargeConsumedMaterial")}
                    value="3"
                  />
                  <Tab icon={<Icons.CashCoin />} label={t("cost")} value="4" />
                  <Tab
                    icon={<Icons.ArrowsExpand />}
                    label={t("discountCharge")}
                    value="5"
                  />
                  <Tab
                    icon={<Icons.UiRadiosGrid />}
                    label={t("pricing")}
                    value="6"
                  />
                </TabList>
              </Box>
              <Paper className="w-100 overflow-visible ">
                <TabPanel value="1" className="p-0 m-0 ">
                  <FactorTable parentLoading={loading} />
                </TabPanel>

                <TabPanel value="3" className="p-0 m-0">
                  <SettingsUsageCharge />
                </TabPanel>

                <TabPanel value="4" className="p-0 m-0">
                  <SettingsCost DefaultCost={defaultCost} />
                </TabPanel>

                <TabPanel value="5" className="p-0 m-0">
                  <SettingsGroupCustomer />
                </TabPanel>

                <TabPanel value="6" className="p-0 m-0">
                  <SettingsPriceType ArchiveFactor={defaultArchive} />
                </TabPanel>
              </Paper>
            </TabContext>
          </div>
        </>
      )}
    </>
  );
};

export default Factor;
